// extracted by mini-css-extract-plugin
module.exports = {"base":"Pagination_base__Tvk_G"};